import { PendingActionsService } from 'sharebase/services/pendingActionsService';

const template = require('./logoutDialog.template');

export type ILogoutDialogService = LogoutDialogService;
export class LogoutDialogService {
	public static $inject = [
		'$mdDialog',
		'sbPendingActionsService'
	];

	constructor(
		private $mdDialog:any,
		private sbPendingActionsService:PendingActionsService
	){
	}

	public open(event) {
		return this.$mdDialog.show({
			controller: () => this,
			controllerAs: 'vm',
			template,
			targetEvent: event
		})
	}

	public dismiss() {
		this.sbPendingActionsService.clearMessages();
		this.$mdDialog.hide();
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/services/logoutDialogService/logoutDialogService.ts